import { LOCAL_STORAGE_LANGUAGE_KEY } from '@constants';

const setLanguageToLC = (language: string) => {
  if (language) {
    localStorage.setItem(LOCAL_STORAGE_LANGUAGE_KEY, language);
  }
};

export default setLanguageToLC;
